// frontend/src/api.js
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL, // Should be https://...:446
    withCredentials: true // Usually not needed when sending Auth header manually
});

// Add a request interceptor to include the token
api.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('uma_token');
        if (token) {
            // If token exists, add it to the Authorization header
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config; // Return the modified config
    },
    (error) => {
        // Handle request error
        return Promise.reject(error);
    }
);

// Optional: Add a response interceptor to handle 401 errors (e.g., redirect to login)
api.interceptors.response.use(
    (response) => response, // Just return successful responses
    (error) => {
        if (error.response && error.response.status === 401) {
            // If we get a 401 Unauthorized (e.g., expired token)
            console.error("Unauthorized or expired token, logging out.");
            localStorage.removeItem('uma_token');
            // Redirect to UMA login page (correct subpath)
            window.location.href = '/umaf/login';
        } else {
            // Enhanced error logging
            console.error("API Error Details:", {
                url: error.config?.url,
                method: error.config?.method,
                status: error.response?.status,
                statusText: error.response?.statusText,
                responseData: error.response?.data,
                message: error.message
            });
        }
        return Promise.reject(error);
    }
);

export default api;

// ---------------------------------------------------------------------------
// Debug-enabled wrapper: identical functionality, extra console tracing
// ---------------------------------------------------------------------------
const apiWithDebug = {
    get: async (url, config) => {
        console.log(`API GET Request: ${url}`);
        try {
            const response = await api.get(url, config);
            return response;
        } catch (error) {
            console.error(`API GET Error (${url}):`, error);
            throw error;
        }
    },

    post: async (url, data, config) => {
        console.log(`API POST Request: ${url}`, { requestData: data });
        try {
            const response = await api.post(url, data, config);
            console.log(`API POST Success (${url}):`, { responseData: response.data });
            return response;
        } catch (error) {
            console.error(`API POST Error (${url}):`, error);
            if (error.response) {
                console.error('Error Response:', error.response.data);
            }
            throw error;
        }
    },

    // Other HTTP verbs can be added here following the same pattern (put, delete, etc.)
};

export { apiWithDebug };